/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import styled from 'styled-components';
import Radio from '@ui-elements/Radio';
import MUIRadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

import { FONT_SIZES } from '~/assets/styles/base';

type StyledRadioGroupProps = {
  $isVertical?: boolean;
  $styles: {} | [];
};

const StyledRadioGroup = styled(MUIRadioGroup)<StyledRadioGroupProps>`
  flex-direction: ${({ $isVertical }) => ($isVertical ? 'column' : 'unset')};
  ${({ $styles }) => $styles}
`;

const Label = styled.span`
  font-size: ${FONT_SIZES.bodyDefault};
`;

const StyledFormControl = styled(FormControl)`
  width: 100%;
`;

const StyledFormControlLabel = styled(FormControlLabel)`
  width: auto;
`;

type RadioProps = {
  value: string | number;
  label?: string;
};

type Props = {
  radios: RadioProps[];
  defaultValue?: string | number;
  name?: string;
  disabled?: boolean;
  isVertical?: boolean;
  handleChange?: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
  styles?: {} | [];
};

const RadioGroup: React.FC<Props> = ({
  radios,
  defaultValue,
  disabled = false,
  name,
  isVertical = false,
  handleChange = () => {},
  styles = {},
}): JSX.Element => (
  <StyledFormControl data-testid="uiParts-RadioGroup">
    <StyledRadioGroup
      defaultValue={defaultValue}
      name={name}
      onChange={handleChange}
      $isVertical={isVertical}
      $styles={styles}
    >
      {radios.map((radio) => (
        <StyledFormControlLabel
          data-testid={`uiParts-RadioGroup-radio-${radio.value}`}
          key={radio.value}
          label={<Label>{radio.label}</Label>}
          disabled={disabled}
          control={<Radio value={radio.value} />}
        />
      ))}
    </StyledRadioGroup>
  </StyledFormControl>
);

export default RadioGroup;
